import React from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';

export const Center = React.memo(({ children, ...otherProps }: FlexProps) => {
  return (
    <Flex justifyContent="center" {...otherProps}>
      {children}
    </Flex>
  );
});
